/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
// eslint-disable-next-line no-unused-vars
import {
    Idea,
    IdeaFromJSON,
    IdeaToJSON,
    UserAdmin,
    UserAdminFromJSON,
    UserAdminToJSON,
} from './';

/**
 * 
 * @export
 * @interface IdeaVoteUpdateAdminResponse
 */
export interface IdeaVoteUpdateAdminResponse {
    /**
     * 
     * @type {Idea}
     * @memberof IdeaVoteUpdateAdminResponse
     */
    idea: Idea;
    /**
     * 
     * @type {UserAdmin}
     * @memberof IdeaVoteUpdateAdminResponse
     */
    voter: UserAdmin;
}

export function IdeaVoteUpdateAdminResponseFromJSON(json: any): IdeaVoteUpdateAdminResponse {
    return {
        
        'idea': IdeaFromJSON(json['idea']),
        
        'voter': UserAdminFromJSON(json['voter']),
    };
}

export function IdeaVoteUpdateAdminResponseToJSON(value?: IdeaVoteUpdateAdminResponse): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        
        'idea': IdeaToJSON(value.idea),
        
        'voter': UserAdminToJSON(value.voter),
    };
}


